import React from 'react'
import './styles/index.scss'

const ButtonLoadingV2 = () => (
  <div className="button__loader button__loader-v2" />
)

export default ButtonLoadingV2
